import {getDevCenterDataStore} from '../../app/store';
const initialState = { id: 'static-home-section'};

// list of all possible slices for lhs method
const lhsReducerData = state =>state.lhsReducer;
const firstLevelKeySlice = state => state.lhsReducer.firstLevelKey;
const secondLevelKeySlice = state => state.lhsReducer.secondLevelKey;
const summarySlice = state => state.lhsReducer.summary;
const methodType = state => state.lhsReducer.methodType;
const path = state => state.lhsReducer.path;
const description = state => state.lhsReducer.description;
const hasBodyParams = state => state.lhsReducer.hasBodyParams;
// const disableProcessorDropDown = state => state.lhsReducer.disableProcessorDropDown;
const disableMerchantCreds = state => state.lhsReducer.disableMerchantCreds;
const jsonSource = state => state.lhsReducer.jsonSource;
const authorizationType = state => state.lhsReducer.authorizationType;
const firstLevelApiLifeCycle = state =>state.lhsReducer.firstLevelApiLifeCycle;
const secondLevelApiLifeCycle = state =>state.lhsReducer.secondLevelApiLifeCycle;
const thirdLevelApiLifeCycle = state =>state.lhsReducer.thirdLevelApiLifeCycle;
const enabledDownload = state =>state.lhsReducer.enabledDownload;
const sendDisabled = state =>state.lhsReducer.sendDisabled;
const customHeaders = state =>state.lhsReducer.customHeaders;
const isClientSideApi = state =>state.lhsReducer.isClientSideApi;
const overrideMerchantCredential = state =>state.lhsReducer.overrideMerchantCredential;
const disableDefaultMerchantCreds = state =>state.lhsReducer.disableDefaultMerchantCreds;
const disableProcessorDropdown = state =>state.lhsReducer.disableProcessorDropdown;
const customHeadersSelectedValue = state =>state.lhsReducer.customHeadersSelectedValue;
const selectedApi = state =>state.lhsReducer.selectedApi;
const noAuth = state => state.noAuth;
const secondLevelKeyFlag = state =>state.lhsReducer.secondLevelKeyFlag;
const homeSectionLinkFlag = state => state.lhsReducer.homeSectionLinkFlag;
const customHeaderCounter = state => state.lhsReducer.customHeaderCounter;
const cybsProductMapJson = state => state.lhsReducer.cybsProductMapJson;
const partnerProductMapJson = state => state.lhsReducer.partnerProductMapJson;
const cybsMisMatchedProductJson = state => state.lhsReducer.cybsMisMatchedProductJson;
const deprecatedProductsList = state => state.lhsReducer.deprecatedProductsList;
const isJstreeExpansionLimited = state => state.lhsReducer.isJstreeExpansionLimited;
const xApiDependencies = state => state.lhsReducer.xApiDependencies;
const prerequisitesFlag = state => state.lhsReducer.prerequisitesFlag;
 
// function to generate lhs reducer
function lhsReducer(state=initialState, action)
{
    if(action != undefined)
    {
        switch(action.type)
    {
        case 'UPDATE_FIRST_LEVEL_KEY':
            return {
            ...state,
            // and update the copy with the new value
            firstLevelKey : action.firstLevelKey
            }
        case 'UPDATE_SECOND_LEVEL_KEY':
            return {
                ...state,
                // and update the copy with the new value
                secondLevelKey : action.secondLevelKey
            }
        case 'UPDATE_SUMMARY':
            return {
                    ...state,
                    // and update the copy with the new value
                summary : action.summary
            }        
        case 'UPDATE_METHOD_TYPE':
            return{
                ...state,
                methodType: action.methodType
            }
        case 'UPDATE_PATH':
            return{
                ...state,
                path: action.path
            }
        case 'UPDATE_DESCRIPTION':
            return{
                ...state,
                description: action.description
            }
        case 'UPDATE_HAS_BODY_PARAMS':
            return{
                    ...state,
                    hasBodyParams: action.hasBodyParams
            }
        case 'UPDATE_DISABLE_PROCESSOR_DROPDOWN':
            return{
                ...state,
                disableProcessorDropDown: action.disableProcessorDropDown
            }
        case 'UPDATE_DISABLE_MERCHANT_CREDS':
            return{
                    ...state,
                    disableMerchantCreds: action.disableMerchantCreds
            }    
        case 'UPDATE_JSON_SOURCE':
            return{
                ...state,
                jsonSource: action.jsonSource
            }
        case 'UPDATE_AUTHORIZATION_TYPE':
            return{
                ...state,
            authorizationType : action.authorizationType
            }
        case 'UPDATE_FIRST_LEVEL_API_LIFE_CYCLE':
                return{
                    ...state,
                    firstLevelApiLifeCycle : action.firstLevelApiLifeCycle
            }
        case 'UPDATE_SECOND_LEVEL_API_LIFE_CYCLE':
                return{
                    ...state,
                    secondLevelApiLifeCycle : action.secondLevelApiLifeCycle
            }
        case 'UPDATE_THIRD_LEVEL_API_LIFE_CYCLE':
                return{
                    ...state,
                    thirdLevelApiLifeCycle : action.thirdLevelApiLifeCycle
            }
        case 'UPDATE_ENABLE_DOWNLOAD':
                return{
                    ...state,
                    enabledDownload : action.enabledDownload
            }
        case 'UPDATE_SEND_DISABLED':
                return{
                    ...state,
                    sendDisabled : action.sendDisabled
            }
        case 'UPDATE_IS_CLIENT_SIDE_API':
                return{
                    ...state,
                    isClientSideApi : action.isClientSideApi
            }  
        case 'UPDATE_CUSTOM_HEADERS':
                return{
                    ...state,
                    customHeaders : action.customHeaders
            }
        case 'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE':
                return{
                    ...state,
                    customHeadersSelectedValue : action.customHeadersSelectedValue
            }
        case 'UPDATE_CUSTOM_HEADERS_COUNTER':
                    return{
                        ...state,
                        customHeaderCounter : action.customHeaderCounter
                }        
        case 'UPDATE_OVERRIDE_CREDENTIALS':
                return{
                    ...state,
                    overrideMerchantCredential : action.overrideMerchantCredential
            }
        case 'UPDATE_DISABLE_DEFAULT_MERCHANT_CREDENTIALS':
                return{
                    ...state,
                    disableDefaultMerchantCreds : action.disableDefaultMerchantCreds
            }
        case 'UPDATE_DISABLE_PROCESSORDROPDOWN':
                return{
                    ...state,
                    disableProcessorDropdown : action.disableProcessorDropdown
            }
        case 'UPDATE_SELECTED_API':
               return{
                   ...state,
                   selectedApi : action.selectedApi
               }
        case 'UPDATE_NO_AUTH':
                return{
                    ...state,
                    noAuth  : action.noAuth
                }
        case 'UPDATE_SECOND_LEVEL_KEY_FLAG':
               return{
                   ...state,
                   secondLevelKeyFlag : action.secondLevelKeyFlag
               }
        case 'UPDATE_HOME_SECTION_LINK_FLAG':
            return{
                ...state,
                homeSectionLinkFlag : action.homeSectionLinkFlag
            }
        case 'UPDATE_CYBS_PRODUCT_MAP_JSON':
            return {
                ...state,
                cybsProductMapJson: action.cybsProductMapJson
            }
        case 'UPDATE_PARTNER_PRODUCT_MAP_JSON':
            return {
                ...state,
                partnerProductMapJson: action.partnerProductMapJson
            }    
        // cybsMisMatchedProductJson variables and logic will be removed when this Mismatched Product Family Names are changed in SPEC     
        case 'UPDATE_CYBS_MIS_MATCHED_PRODUCT_JSON':
            return {
                ...state,
                cybsMisMatchedProductJson: action.cybsMisMatchedProductJson
            }
        case 'UPDATE_DEPRECATED_PRODUCTS_LIST':
            return {
                ...state,
                deprecatedProductsList: action.deprecatedProductsList
            }    
        case 'UPDATE_IS_JSTREE_EXPANSION_LIMITED':
            return{
                ...state,
                isJstreeExpansionLimited : action.isJstreeExpansionLimited
            }
        case 'UPDATE_X_API_DEPENDENCIES':
            return{
                ...state,
                xApiDependencies : action.xApiDependencies
            } 
        case 'UPDATE_PREREQUISITES_FLAG':
            return{
                ...state,
                prerequisitesFlag: action.prerequisitesFlag
            }               
        default:
            return state        
    }
    }
}

// function to get lhs reducer data 
function getLHSReducerData()
{
    return lhsReducerData(getDevCenterDataStore().getState());
}

// get first level key used in development center
function getFirstLevelKey()
{
    return firstLevelKeySlice(getDevCenterDataStore().getState());
}

// get second level key used in development center
function getSecondLevelKey()
{
    return secondLevelKeySlice(getDevCenterDataStore().getState());
}

// get the summary key of the selected component in dev center
function getSummaryDetails()
{
    return summarySlice(getDevCenterDataStore().getState());
}

// get the method Type of the selected key in dev center
function getMethodType()
{
    return methodType(getDevCenterDataStore().getState());
}


// get the path of the selected key in dev center
function getPath()
{
    return path(getDevCenterDataStore().getState());
}

// get the description of the selected key in dev center
function getDescription()
{
    return description(getDevCenterDataStore().getState());
}

// get the has Body Params key of the selected key in dev center
function getHasBodyParams()
{
    return hasBodyParams(getDevCenterDataStore().getState());
}

// get the disable Processor Drop Down key of the selected key in dev center
function getDisableProcessorDropDown()
{
    return disableProcessorDropdown(getDevCenterDataStore().getState());
}

// get the disable Merchant Creds key of the selected key in dev center
function getDisableMerchantCreds()
{
    return disableMerchantCreds(getDevCenterDataStore().getState());
}

// get the jsonSource of the selected json data key
function getJsonSource()
{
    return jsonSource(getDevCenterDataStore().getState());
}

// get the authorization of selected json data key
function getAuthorizationType()
{
    return authorizationType(getDevCenterDataStore().getState());
}

// get the first level api life cycle
function getFirstLevelApiLifeCycle()
{
    return firstLevelApiLifeCycle(getDevCenterDataStore().getState());
}
// get the second level api life cycle
function getSecondLevelApiLifeCycle()
{
    return secondLevelApiLifeCycle(getDevCenterDataStore().getState());
}

// get the third level api life cycle
function getThirdLevelApiLifeCycle()
{
    return thirdLevelApiLifeCycle(getDevCenterDataStore().getState());
}
// get the third level api life cycle
function getCustomHeaders()
{
    return customHeaders(getDevCenterDataStore().getState());
}
// get the third level api life cycle
function getIsClientSideApi()
{
    return isClientSideApi(getDevCenterDataStore().getState());
}
// get the third level api life cycle
function getSendDisabled()
{
    return sendDisabled(getDevCenterDataStore().getState());
}
// get the third level api life cycle
function getEnabledDownload()
{
    return enabledDownload(getDevCenterDataStore().getState());
}
// get the override merchant credentials
function getOverRideMerchantCredentials()
{
    return overrideMerchantCredential(getDevCenterDataStore().getState());
}

// get the override merchant credentials
function getDisableDefaultMerchantCredentials()
{
    return disableDefaultMerchantCreds(getDevCenterDataStore().getState());
}
// get the custom Headers Selected Value
function getCustomHeadersSelectedValue()
{
    return customHeadersSelectedValue(getDevCenterDataStore().getState());
}
//get the selected API
function getSelectedApi()
{
    return selectedApi(getDevCenterDataStore().getState());
}

function getNoAuth()
{
    return noAuth(getDevCenterDataStore().getState());
}
function getSecondLevelKeyFlag(){
    return secondLevelKeyFlag(getDevCenterDataStore().getState());
}
function getHomeSectionLinkFlag(){
    return homeSectionLinkFlag(getDevCenterDataStore().getState());
}
function getCustomHeaderCounter(){
    return customHeaderCounter(getDevCenterDataStore().getState());
}
function getCybsProductMapJson(){
    return cybsProductMapJson(getDevCenterDataStore().getState());
}
function getPartnerProductMapJson(){
    return partnerProductMapJson(getDevCenterDataStore().getState());
}
function getCybsMisMatchedProductJson(){
    return cybsMisMatchedProductJson(getDevCenterDataStore().getState());
}
function getDeprecatedProductsList(){
    return deprecatedProductsList(getDevCenterDataStore().getState());
}
function getIsJstreeExpansionLimited(){
    return isJstreeExpansionLimited(getDevCenterDataStore().getState());
}
function getXApiDependencies(){
    return xApiDependencies(getDevCenterDataStore().getState());
}
function getPrerequisitesFlag(){
    return prerequisitesFlag(getDevCenterDataStore().getState());
}
export default lhsReducer;
export {getLHSReducerData,getFirstLevelKey,getSecondLevelKey,getSummaryDetails,getMethodType,getPath,getDescription,getHasBodyParams,getDisableProcessorDropDown,getDisableMerchantCreds,getJsonSource,getAuthorizationType,getFirstLevelApiLifeCycle,getSecondLevelApiLifeCycle,getThirdLevelApiLifeCycle,getCustomHeaders,getIsClientSideApi,getSendDisabled,getEnabledDownload,getOverRideMerchantCredentials,getDisableDefaultMerchantCredentials,getCustomHeadersSelectedValue,getSelectedApi,getNoAuth,getSecondLevelKeyFlag,getHomeSectionLinkFlag,getCustomHeaderCounter,getIsJstreeExpansionLimited,getXApiDependencies,getPrerequisitesFlag,getCybsProductMapJson,getPartnerProductMapJson,getCybsMisMatchedProductJson,getDeprecatedProductsList}
